// local imports
import { darkGrey } from '~/colors'
import { contentWidth } from '~/dims'

export default {
    container: {
        borderColor: darkGrey,
        flex: 1,
        overflow: 'hidden'
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        width: '100%',
        alignSelf: 'center',
        flexDirection: 'column'
    }
}



// WEBPACK FOOTER //
// ./src/views/Root/styles.js